var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "op-submit-bar" },
    [
      _c("div", { staticClass: "info" }, [
        _c("span", { staticClass: "num" }, [
          _vm._v("共" + _vm._s(_vm.num) + "件,")
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("合计金额")]),
        _vm._v(" "),
        _c("span", { staticClass: "price" }, [
          _vm._v("¥" + _vm._s(_vm.price.toFixed(2)))
        ])
      ]),
      _vm._v(" "),
      _c(
        "van-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.btnShow,
              expression: "btnShow"
            }
          ],
          staticClass: "submit-btn",
          attrs: { round: "", type: "primary" },
          on: { click: _vm.submit }
        },
        [_vm._v(_vm._s(_vm.buttonText))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }